<ng-container [ngSwitch]="question.type">

  <div *ngSwitchCase="'ImageSelect'">
    <app-image-select-question [question]="question" [showHeader]="showHeader"></app-image-select-question>
  </div>
  <div *ngSwitchCase="'Email'">
    <app-email-question [question]="question"></app-email-question>
  </div>
  <div *ngSwitchCase="'Text'">
    <app-text-question [question]="question"></app-text-question>
  </div>
  <div *ngSwitchCase="'Date'">
    <app-date-question [question]="question"></app-date-question>
  </div>
  <div *ngSwitchCase="'TelNo'">
    <app-tel-no-question [question]="question"></app-tel-no-question>
  </div>
  <div *ngSwitchCase="'Slider'">
    <app-slider-question [question]="question"></app-slider-question>
  </div>
  <div *ngSwitchCase="'Select'">
    <app-button-select-question [question]="question"></app-button-select-question>
  </div>
  <div *ngSwitchCase="'ChildrenAges'">
    <app-children-question [question]="question"></app-children-question>
  </div>
  <div *ngSwitchCase="'NormalSelect'">
    <app-select-question [question]="question"></app-select-question>
  </div>
  <div *ngSwitchCase="'DayOfMonthSelect'">
    <app-day-of-month-question [question]="question"></app-day-of-month-question>
  </div>
  <div *ngSwitchCase="'Time'">
    <app-time-question [question]="question"></app-time-question>
  </div>
  <div *ngSwitchCase="'Address'">
    <app-address-selector-question [question]="question"></app-address-selector-question>
  </div>
  <div *ngSwitchCase="'Numeric'">
    <app-numeric-question [question]="question"></app-numeric-question>
  </div>
  <div *ngSwitchCase="'SelectDate'">
    <app-select-date-question [question]="question"></app-select-date-question>
  </div>
  <div *ngSwitchCase="'Display'">
    <app-display [question]="question"></app-display>
  </div>
  <div *ngSwitchCase="'Confirm'">
    <app-confirm-question [question]="question"></app-confirm-question>
  </div>
  <div *ngSwitchCase="'SiteContent'">
    <app-site-content [key]="question.key" [type]="question.options.Type" [showTitle]="question.options.ShowTitle">      
    </app-site-content>
  </div>

  <div *ngSwitchDefault>
    To Implement {{question.type}}
  </div>

</ng-container>

<div class="invalid-feedback d-block" *ngIf="!!question.error">
  {{question.error}} <a class="retry" *ngIf="question.retryValidation" (click)="question.retryValidation()">(try again)</a>
</div>
